var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.data_loaded)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"red"}})],1):_vm._e(),_c('div',[_c('apexchart',{ref:"chart",attrs:{"type":"bar","height":"300","options":_vm.chartOptions,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }